module.exports = __webpack_public_path__ + "img/doll liberation front.aa0d82e2.png";